export const AUTH_SESSION_ACTIVE_WINDOW_MS = 5 * 60 * 1000;
export const AUTH_SESSION_TOKEN_EXPIRY_BUFFER_MS = 10_000;

export const resolveInactivitySessionActiveUntil = ({ now }: { now: number }) => {
  return now + AUTH_SESSION_ACTIVE_WINDOW_MS;
};
